// extracted by mini-css-extract-plugin
export default {"cls1":"Go7mWbPHwhoL3XtxEmmq","cls2":"VUi1MNoVz4KgYk_ajXVi Go7mWbPHwhoL3XtxEmmq"};